import React from 'react';

export default function PrivacyModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-sm flex items-center justify-center p-4 z-50 animate-fadeIn">
      <div className="bg-slate-900 border border-slate-800 rounded-3xl max-w-2xl w-full p-8 relative shadow-2xl text-left space-y-4 max-h-[85vh] overflow-y-auto">
        <button 
          onClick={onClose}
          className="absolute top-5 right-5 text-slate-400 hover:text-white font-bold text-xl bg-slate-800 w-8 h-8 rounded-full flex items-center justify-center transition cursor-pointer"
          aria-label="Cerrar modal"
        >
          ✕
        </button>

        <div className="flex items-center space-x-3">
          <span className="text-3xl">🛡️</span>
          <div>
            <h3 className="text-2xl font-bold text-white">Políticas de Privacidad y Habeas Data</h3>
            <p className="text-xs text-emerald-400 font-medium">Cumplimiento Ley 1581 de 2012 y Decreto 1377 de 2013</p>
          </div>
        </div>
        <hr className="border-slate-800" />

        <div className="text-xs space-y-3 text-slate-300 leading-relaxed">
          <p>
            En cumplimiento con la legislación colombiana de Protección de Datos Personales (Ley 1581 de 2012), la <strong>Institución Educativa Enrique Olaya Herrera</strong> informa que los datos de la plataforma <strong>English EOH</strong> se usan exclusivamente con fines pedagógicos.
          </p>
        </div>

        <button
          onClick={onClose}
          className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-2.5 rounded-xl transition text-xs mt-2 cursor-pointer"
        >
          Entendido y Aceptado
        </button>
      </div>
    </div>
  );
}
